import React, {useEffect} from 'react';
import {useResetUserMigrationMutation} from "../../../../../redux/apiSlice";
import {Modal} from "react-bootstrap";
import cogoToast from "cogo-toast";

function ResetMigrationModal({showResetMigrationModal, onHide, details, tableRef}) {
    const [
        resetMigration, // This is the mutation trigger
        {
            isLoading: isResetting,
            isSuccess: resetSuccessful,
        }, // This is the destructured mutation result
    ] = useResetUserMigrationMutation()

    /* Close Modal on Successful Reset */
    useEffect(() => {
        if (resetSuccessful) {
            tableRef.current.refresh();
            cogoToast.success("Migration Successfully Reset")
            onHide();
        }
    }, [resetSuccessful, onHide, tableRef]);

    /* Reset Migration */
    const onSubmit = () => {
        resetMigration({
            userId: details?.user?.unique_id,
            email: details?.email
        });
    }

    return (
        <Modal
            show={showResetMigrationModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isResetting ? "static" : true}
            keyboard={!isResetting}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Reset Migration
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>

            <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                <p>{`Are you sure you want to reset migration for ${details?.email}?`}</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isResetting}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={isResetting}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                    onClick={onSubmit}
                >
                    Reset
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default ResetMigrationModal;